




















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class EdrPatientDetailHeader extends Vue {
  @Prop()
  private patient: any;
  @Prop()
  private projectId: any;
  private get user() {
    return this.$store.state.user;
  }
  private goBack() {
    this.$router.replace({
      path: "/main/sjzx/zbsjk-list",
    });
  }
}
